import { Button, Collapse, Hidden, Paper, TextField, Typography } from '@material-ui/core';
import Snackbar from 'components/Shared/Snackbar';
import { WithStyles } from 'decorators/withStyles';
import { IOrderBump, IProductOrderBump } from 'interfaces/orderbump';
import React, { Fragment, PureComponent } from 'react';
import rxjsOperators from 'rxjs-operators';

import { orderBumpService } from '../../../../../services/orderBumpService';
import PreviewOrderBump from './components/PreviewOrderBump';
import SelectProduct from './components/SelectProduct';
import StepDescription from './components/Step';

interface IState {
  mainProductSelect: IProductOrderBump;
  bumpProductSelect: IProductOrderBump;
  mainProducts: IProductOrderBump[];
  bumpProducts: IProductOrderBump[];
  description: string;
}

interface IProps {
  orderBump?: IOrderBump;
  renderDash: () => void;
  classes?: any;
}

@WithStyles(theme => ({
  '@global': {
    'content-element': {
      margin: '69px 0 0 0'
    }
  },
  containerPaper: {
    padding: '24px',
    '& .MuiInput-underline:after': {
      borderBottomColor: '#596375'
    }
  },
  header: {
    height: '93px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '20px',
    backgroundColor: '#fff'
  },
  title: {
    color: theme.variables.colors['primaryColor']
  },
  containerStep: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  lineDiv: {
    width: '100%',
    height: '1px',
    backgroundColor: '#D9D9D9',
    margin: '48px 0'
  },
  buttonSubmit: {
    marginTop: '70px',
    fontWeight: 400,
    backgroundColor: '#009358',
    marginLeft: '10px',
    color: '#fff'
  },
  buttonCancel: {
    marginTop: '70px',
    fontWeight: 400,
    backgroundColor: 'transparent',
    color: theme.variables.colors['primaryColor'],
    boxSizing: 'border-box'
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  }
}))
export default class RegisterOrderBump extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    const { orderBump } = props;
    this.state = !orderBump
      ? {
          mainProductSelect: null,
          bumpProductSelect: null,
          description: '',
          mainProducts: [],
          bumpProducts: []
        }
      : {
          mainProductSelect: orderBump.owner,
          bumpProductSelect: orderBump.bump,
          description: orderBump.description,
          mainProducts: [],
          bumpProducts: []
        };
  }

  onChange = (value: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    this.setState({ description: value.target.value });
  };

  onSubmit = () => {
    const { mainProductSelect, bumpProductSelect, description } = this.state;
    const { orderBump, renderDash } = this.props;

    if (!orderBump.id) {
      orderBumpService
        .createOrderBump(mainProductSelect.id, bumpProductSelect.id, description)
        .pipe(rxjsOperators.loader(), rxjsOperators.bindComponent(this))
        .subscribe(() => {
          Snackbar.show('Cadastrado com sucesso!');
          renderDash();
        });
    } else {
      orderBumpService
        .updateOrderBump(orderBump.id, mainProductSelect.id, bumpProductSelect.id, description, orderBump.ativo)
        .pipe(rxjsOperators.loader(), rxjsOperators.bindComponent(this))
        .subscribe(() => {
          Snackbar.show('Alterado com sucesso!');
          renderDash();
        });
    }
  };

  handleSubmitMainProduct = (mainProductSelect: IProductOrderBump) => {
    this.setState({ mainProductSelect });
    orderBumpService.getBumpProducts(mainProductSelect.id).subscribe(bumpProducts => this.setState({ bumpProducts }));
  };

  handleSubmitOrderBumpProduct = (bumpProductSelect: IProductOrderBump) => {
    this.setState({ bumpProductSelect });
  };

  componentDidMount() {
    const { mainProductSelect } = this.state;
    if (!!mainProductSelect) {
      orderBumpService.getBumpProducts(mainProductSelect.id).subscribe(bumpProducts => this.setState({ bumpProducts }));
    }
    orderBumpService.getProducts().subscribe(mainProducts => this.setState({ mainProducts }));
  }

  render() {
    const { classes, orderBump, renderDash } = this.props;
    const { mainProductSelect, bumpProductSelect, mainProducts, bumpProducts, description } = this.state;

    return (
      <Fragment>
        <Hidden mdUp>No momento, não é possível realizar o cadastro de order bump em aparelhos mobile</Hidden>
        <Hidden smDown>
          <Paper elevation={0}>
            <div className={classes.header}>
              <Typography className={classes.title} variant="h5">
                Escolhendo o Order Bump
              </Typography>
            </div>
            <div className={classes.containerPaper}>
              <div className={classes.containerStep}>
                <StepDescription
                  stepNumber="1"
                  title="Produto Principal"
                  component={
                    <p>
                      Escolha o produto principal, no checkout deste produto irá aparecer a oferta order bump. O link do
                      checkout não sofrerá mudanças.
                    </p>
                  }
                />
                <SelectProduct
                  buttonText={`${!!mainProductSelect ? 'Trocar' : 'Escolher'} Produto Principal`}
                  productsList={mainProducts}
                  handleSubmit={this.handleSubmitMainProduct}
                  productSelected={mainProductSelect}
                />
              </div>

              <Collapse in={!!mainProductSelect}>
                <div className={classes.lineDiv} />
                <div className={classes.containerStep}>
                  <StepDescription
                    stepNumber="2"
                    title="Produto Order Bump"
                    component={
                      <p>
                        Este produto complementar será utilizado como oferta no checkout do produto principal.
                        Recomendamos não utilize produto com valor mais alto que o valor do produto principal.
                      </p>
                    }
                  />
                  <SelectProduct
                    buttonText={`${!!bumpProductSelect ? 'Trocar' : 'Escolher'} Produto Order Bump`}
                    productsList={bumpProducts}
                    handleSubmit={this.handleSubmitOrderBumpProduct}
                    productSelected={bumpProductSelect}
                  />
                </div>
              </Collapse>

              <Collapse in={!!bumpProductSelect && !!mainProductSelect}>
                <div className={classes.lineDiv} />

                <div className={classes.containerStep}>
                  <StepDescription
                    stepNumber="3"
                    title="Titulo do Produto Bumps"
                    component={
                      <TextField
                        defaultValue={!orderBump ? '' : orderBump.description}
                        color="#009358"
                        style={{ width: '383px' }}
                        onChange={this.onChange}
                      />
                    }
                  />
                  {!!bumpProductSelect && (
                    <PreviewOrderBump
                      price={bumpProductSelect.price}
                      image={bumpProductSelect.image}
                      description={description}
                    />
                  )}
                </div>
              </Collapse>

              <div className={classes.buttonContainer}>
                <Button className={classes.buttonCancel} onClick={renderDash}>
                  Cancelar
                </Button>
                {!!bumpProductSelect && !!mainProductSelect && (
                  <Button className={classes.buttonSubmit} onClick={this.onSubmit}>
                    Salvar Order Bump
                  </Button>
                )}
              </div>
            </div>
          </Paper>
        </Hidden>
      </Fragment>
    );
  }
}
